import React from "react";
import { compose } from "src/helpers";
import {
    withHookForAggregateConcept,
    withHookForConcepts,
} from "src/modules/concept/operations";
import { withStateAndActionsForConcept } from "src/modules/concept/resolvers";
import ListView from "./component";

const List: React.FC = (props: any) => {
    return <ListView {...props} />;
};

export default compose(
    withStateAndActionsForConcept,
    withHookForConcepts,
    withHookForAggregateConcept,
)(List);
